import React, { useState } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import CategoryBanner from "./Category-Banner";
import CourseFilter from "./Filter/CourseFilter";
import { useAppContext } from "@/context/Context";

const CategoryMarket = (stores) => {
    const router = useRouter();
    const path = router.pathname;
    const { toggle, setToggle } = useAppContext();
    const [filterToggle, setFilterToggle] = useState(true);

    const item = stores

    return (
        <>
            <div className="rbt-page-banner-wrapper bg-primary">
                <div className="rbt-banner-image"></div>

                <div className="rbt-banner-content">
                    <div className="rbt-banner-content-top">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="title-wrapper">
                                        <h1 className="title mb--0 text-white">Market Place</h1>
                                        <Link href="#" className="rbt-badge-2">
                                            <div className="image">🎉</div>
                                            {item.length} Items
                                        </Link>
                                    </div>
                                    <p style={{ color: "#FFF", opacity: '.85', paddingBottom: '4rem' }}>Access Books, Worksheets, Templates & other Digital Assets To Accelerate Your Results.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className="rbt-course-top-wrapper mt--40 mt_sm--20">
                        <div className="container">
                            <div className="row g-5 align-items-center">
                                <div className="col-lg-5 col-md-12">
                                    <div className="rbt-sorting-list d-flex flex-wrap align-items-center">
                                        <div className="rbt-short-item switch-layout-container">
                                            <ul className="course-switch-layout">
                                                <li className="course-switch-item">
                                                    <button
                                                        className={`rbt-grid-view ${toggle ? "active" : ""
                                                            }`}
                                                        title="Grid Layout"
                                                        onClick={() => setToggle(!toggle)}
                                                    >
                                                        <i className="feather-grid"></i>{" "}
                                                        <span className="text">Grid</span>
                                                    </button>
                                                </li>
                                                <li className="course-switch-item">
                                                    <button
                                                        className={`rbt-grid-view ${!toggle ? "active" : ""
                                                            }`}
                                                        title="List Layout"
                                                        onClick={() => setToggle(!toggle)}
                                                    >
                                                        <i className="feather-list"></i>{" "}
                                                        <span className="text">List</span>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {path === "/course-filter-one-open" ? (
                                <CourseFilter />
                            ) : (
                                <CourseFilter filterToggle={filterToggle} />
                            )}
                        </div>
                    </div> */}
                </div>
            </div>
        </>
    );
};

export default CategoryMarket;
